<template>
    <div style="min-height: 100vh; display: flex; flex-direction: column;">
        <ApplicationHeader />
        <div style="flex-grow: 1; width: 100%">
            <slot></slot>
        </div>
        <ApplicationFooter />
        <UNotifications />
        <ApplicationLogin />
        <ApplicationRegistration />
        <ApplicationPageLoader />
    </div>
</template>

<script setup>
const { t } = useI18n()
const loader = usePageLoader()

// Ссылки на страницы модулей WX (бронирование, личный кабинет) открываются полной загрузкой —
// сразу показываем заставку, чтобы вместо белого экрана был плавный переход
const WX_PAGE = /^\/(ru|uz|en)\/(booking|account)\/?(#.*)?$/
function onLinkClick(event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
    const link = event.target.closest?.('a[href]')
    if (!link || link.target === '_blank') return
    const url = new URL(link.href, window.location.href)
    if (url.origin !== window.location.origin || !WX_PAGE.test(url.pathname + url.hash)) return
    // ссылка на ту же страницу (только другой #) не перезагружает её
    if (url.pathname === window.location.pathname) return
    loader.show(/^#\/search/.test(url.hash) ? t('loaderSearch') : t('loaderDefault'))
}

// «Назад» в браузере может вернуть страницу из кэша вместе с открытой заставкой
function onPageShow(event) {
    if (event.persisted) loader.hide()
}

onMounted(() => {
    document.addEventListener('click', onLinkClick)
    window.addEventListener('pageshow', onPageShow)
})
onBeforeUnmount(() => {
    document.removeEventListener('click', onLinkClick)
    window.removeEventListener('pageshow', onPageShow)
})
</script>
